import { render, staticRenderFns } from "./UnitOfMeasureViewGlobal.vue?vue&type=template&id=09c7e730"
import script from "./UnitOfMeasureViewGlobal.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasureViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports